import { z } from 'zod';

import { RequiredString } from './common';

const BookingSchema = z.object({
  date: RequiredString,
  time: RequiredString,
  count: z
    .number({ required_error: 'Please type something' })
    .min(1, 'Quantity must be greater than or equal to 1'),
  fullName: RequiredString,
  phoneNumber: RequiredString.min(7, {
    message: 'Please type minimum 7 characters'
  }),
  email: RequiredString
});

export { BookingSchema };
